// eslint-disable-next-line jira/filename-case
import React from 'react';
import type { MaybeChoreographedComponentProps } from '@jira/platform__choreographer-services/src/types.tsx';
import { shouldBeChoreographed } from '@jira/platform__choreographer-services/src/utils.tsx';
import type { PopupComponentProps, PopupProps } from '@atlaskit/popup/types';
// eslint-disable-next-line no-restricted-imports, jira/restricted/@atlaskit+popup
import { Popup } from '@atlaskit/popup/popup';
import { ChoreographerPopup } from './choreographer-popup.tsx';

export type JiraPopupProps = PopupProps & MaybeChoreographedComponentProps;
// eslint-disable-next-line jira/export/restrict-types-re-export
export type JiraPopupComponentProps = PopupComponentProps;

export const JiraPopup = (props: JiraPopupProps): React.JSX.Element => {
	if (shouldBeChoreographed(props)) {
		const { messageType, ...rest } = props;
		return <ChoreographerPopup {...rest} />;
	}

	const { messageType, messageId, onMessageDisposition, ...rest } = props;
	return <Popup {...rest} />;
};
